const header = [
	{
		'name': "Overview",
		'id': 0,
		'isActive': false
	},
	{
		'name': "Details",
		'id': 1,
		'isActive': false
	},
	{
		'name': "Reviews",
		'id': 2,
		'isActive': false
	}
];

const evaluation = [
	{
		'name': 'All Feedback',
		'id': 1,
		'isActive': false,
		'value': 'total',
		'grade': 0
	},
	{
		'name': '5 stars',
		'id': 2,
		'isActive': false,
		'value': 'good',
		'grade': 1
	},
	{
		'name': '3 stars',
		'id': 3,
		'isActive': false,
		'value': 'medium',
		'grade': 2
	},
	{
		'name': '1 stars',
		'id': 4,
		'isActive': false,
		'value': 'bad',
		'grade': 3
	}
];
export {
	header,
	evaluation
}
